export default "__VITE_ASSET__CM$fKw8t__"